/** The group tutorial: the shared onboarding run at the start of a game, where the whole team walks to the exit elevator. */
export enum GroupTutorialStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed'
}

/** Raw doc the game writes at `courses/{courseId}/onboardingSessions/{platformSessionId}`. */
export type GameOnboardingSessionDoc = {
  id: string
  sessionId?: string
  /** Game timestamps arrive as ISO strings, C# "u" strings (`2026-06-12 08:11:40Z`) or Firestore Timestamps. */
  startedAt?: unknown
  completedAt?: unknown
}

export interface GroupTutorialSummary {
  sessionId: string
  status: GroupTutorialStatus
  startedAt?: string
  completedAt?: string
  /** Minutes since it started, or its full duration once completed. */
  minutes: number | null
  participantNames: string[]
  participantCount: number
  /** App user ids behind participantNames, for matching against the team roster. */
  participantUserIds?: string[]
  /** Still running past the game's auto-proceed timeout — the team is stuck and about to be skipped ahead. */
  isOverdue: boolean
}
